import "../css/Tag.css";

export default function Tag(props) {
  return (
    <div className={`tag ${props.mini ? "tag-mini" : ""}`}>
      <span>{props.text}</span>
      <button
        tabIndex={-1}
        onClick={() => {
          props.onClick(props.text);
        }}
      >
        <img src="/images/close-blue.svg" loading="lazy" alt="Icon"></img>
      </button>
    </div>
  );
}
